module.exports = __webpack_public_path__ + "static/media/icon-hands.861e3fd2.svg";